import { createSelector } from 'reselect'
import { AppState } from 'Store'

const tasks = (state: AppState) => state.modules.task_models.tasks
const tasksFromStats = (state: AppState) => state.modules.task_models.tasksFromStats
const viewDetailTask = (state: AppState) => state.modules.task_models.viewDetailTask
const viewDetailTaskFromStats = (state: AppState) =>
	state.modules.task_models.viewDetailTaskFromStats
const idTask = (state: AppState) => state.modules.task_models.idTask
const idTaskFromStats = (state: AppState) => state.modules.task_models.idTaskFromStats
const stats = (state: AppState) => state.modules.task_models.stats
const activeTag = (state: AppState) => state.modules.task_models.activeTag
const activeTagFromStats = (state: AppState) => state.modules.task_models.activeTagFromStats
const countAllTasks = (state: AppState) => state.modules.task_models.countAllTasks
const countAllTasksFromStats = (state: AppState) => state.modules.task_models.countAllTasksFromStats
const params = (state: AppState) => state.modules.task_models.params
const paramsFromTask = (state: AppState) => state.modules.task_models.paramsFromTask
const statsCreated = createSelector(stats, (stats) => stats?.created ?? 0)
const orderTasks = (state: AppState) => state.modules.task_models.orderTasks
const periodStats = (state: AppState) => state.modules.task_models.periodStats
const period = (state: AppState) => state.modules.task_models.period
const filtersIsVisible = (state: AppState) => state.modules.task_models.filtersIsVisible

export const tasksSelectors = {
	tasks,
	tasksFromStats,
	viewDetailTask,
	viewDetailTaskFromStats,
	idTask,
	idTaskFromStats,
	stats,
	activeTag,
	activeTagFromStats,
	countAllTasks,
	countAllTasksFromStats,
	params,
	paramsFromTask,
	statsCreated,
	orderTasks,
	periodStats,
	period,
	filtersIsVisible,
}
